export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 200,
      // render: 'sortRender',
    },
    {title: '军种编码', dataIndex: 'typeCode', width: 160},
    {title: '名称', dataIndex: 'typeName', width: 160, ellipsis: true},
    {title: '最后修改时间', dataIndex: 'lastUpdatedTime', width: 180, itemType: 'dateTime'},
    {title: '操作', dataIndex: '#', width: 140, render: 'actionRender'},
  ],
  search: [
    {
      name: 'typeCode',
      label: '军种编码',
    },
    {
      name: 'typeNameKeyword',
      label: '名称',
    }
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
